import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({ isOpen: false });
    }

    render({ summary }) {
        return (
            <show-details onclick={this.toggle}>
                <p>{summary} <a>{this.state.isOpen ? 'Show Less' : 'Learn More'}</a></p>
                {this.renderDetails()}
            </show-details>
        );
    }

    renderDetails = () => {
        if (this.state.isOpen) {
            return (
                <p class='details'>
                    {this.props.details}
                </p>
            );
        }

        return null;
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/show-details.js